<template>

  <div class="myCard">
    <header-info-card 
    :leavePeriod="event" 
    v-if="alone">
  </header-info-card>
  <div class="infos-view scroll-y">
    <div class="employee-city">
      <div class="line employee">
        <div class="field">
          {{ $t("editEventCard.employee") }}
        </div>
        <div class="data">
          {{ event.employee }}
        </div>
      </div>
    </div>
    <div class="dates-times">
      <div class="line dates">
        <div class="field">
          {{ $t("editEventCard.date") }}
        </div>
        <div class="data">
          <div class="data">
            {{ $t("editEventCard.from") }}
            {{ event.details.firstDay.split("T")[0] }}
          </div>
          <div class="data">
            {{ $t("editEventCard.to") }}
            {{ event.details.lastDay.split("T")[0] }}
          </div>
        </div>
      </div>
    </div>
    <div class="line">
      <div class="field">
        {{ $t("editEventCard.endsAfternoon") }}
      </div>
      <div class="data">
        <div class="data">
          <v-checkbox v-model="event.endsAfternoon" disabled></v-checkbox>
        </div>
      </div>
    </div>
    <div class="line">
      <div class="field">
        {{ $t("editEventCard.startsAfternoon") }}
      </div>
      <div class="data">
        <v-checkbox v-model="event.startsAfternoon" disabled></v-checkbox>
      </div>
    </div>
    <div class="line type">
      <div class="field">
        {{ $t("editEventCard.types") }}
      </div>
      <div class="data">
        {{
          $enumLeavePeriodType.find((l) => l.value === event.details.type).text
        }}
      </div>
    </div>
    <div class="comment" v-if="event.employeeId === getCurrentUser.id">
      <div class="field">
        {{ $t("editEventCard.comment") }}
      </div>
      <div v-if="event.details.comments" class="data">
        {{ event.details.comments }}
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import HeaderInfoCard from "./headerInfoCard.vue";

export default {
  name: "leave-period-info",
  components: {
    HeaderInfoCard,
  },
  computed:{    
    ...mapGetters("userModule", ["getCurrentUser"]),
  },
  props: {
    linkedIntervention: {},
    users: [],
    event: {
      y: null,
      x: null,
      id: null,
      duration: null,
      display: null,
      details: {},
      color: null,
      eventSiblings: [],
    },
    alone: false,
  },
};
</script>

<style lang="scss">

.myCard{
    height: var(--height-container);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.infos-view {
  padding: 0 10px 0 0;
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  height: 100%;
  margin: 20px 10px 0;

  .line {
    display: flex;
    justify-content: space-between;
    padding: 0 0 15px;
    margin: 0 0 15px;
    border-bottom: 1px solid var(--border-color);
  }

  .field {
    color: rgb(155, 155, 155);
  }

  .comment {
    text-align: justify;
    margin: 0 0 15px;
    padding: 0 0 15px;
    border-bottom: 1px solid var(--border-color);
  }

  .master {
    .data {
      text-align: right;
    }
  }
}
</style>
